import getEnv from '@wetransfer/transfer/config/env';
import request from '@wetransfer/transfer/modules/http/axios/request';

export default {
  send(keys, limit = 100) {
    const random = Math.random() * 100;

    if (random <= limit) {
      const qs = this.generateQueryString(keys);
      request({
        method: 'POST',
        path: `${getEnv().NEXT_PUBLIC_API_URL}/csm?${qs}`,
      });
    }
  },

  generateQueryString(keys) {
    if (Array.isArray(keys)) {
      return keys.map((key) => `${key}=1`).join('&');
    }

    return `${keys}=1`;
  },
};
